import { ServiceOrderStatusTransition } from '@/types/service';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ChevronDown } from 'lucide-react';

interface Props {
  transitions: ServiceOrderStatusTransition[];
  onTransition: (t: ServiceOrderStatusTransition) => void;
}

export default function ServiceOrderTransitionButtons({
  transitions,
  onTransition,
}: Props) {
  if (transitions.length === 0) return null;

  if (transitions.length === 1) {
    return (
      <Button
        variant={transitions[0].to === 'cancelled' ? 'destructive' : 'default'}
        size="sm"
        onClick={() => onTransition(transitions[0])}
      >
        {transitions[0].label}
      </Button>
    );
  }

  const [primary, ...rest] = transitions;
  return (
    <div className="flex items-center">
      <Button
        variant={primary.to === 'cancelled' ? 'destructive' : 'default'}
        size="sm"
        className="rounded-r-none"
        onClick={() => onTransition(primary)}
      >
        {primary.label}
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant={primary.to === 'cancelled' ? 'destructive' : 'default'}
            size="sm"
            className="rounded-l-none border-l px-2"
          >
            <ChevronDown className="w-4 h-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {rest.map((t) => (
            <DropdownMenuItem
              key={t.to}
              onClick={() => onTransition(t)}
              className={t.to === 'cancelled' ? 'text-destructive' : ''}
            >
              {t.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
